const PharmacySites = {
    namespaced: true,
    state: {
        pharmacy_site: {
            site_name: null,
            is_registered: false,
            name: null,
            address: null,
            post_code: null,
            phone: null,
            fax: null,
            email: null,
            pharmacy_group: null,
            blood_providers: null,
            chief_pharmacist_name: null,
            chief_pharmacist_phone: null,
            chief_pharmacist_fax: null,
            chief_pharmacist_email: null,
            chief_pharmacist_rpsgb_number: null,
            technician_name: null,
            technician_phone: null,
            technician_fax: null,
            technician_email: null,
            technician_rpsgb_number: null,
            out_of_hours_contact_name: null,
            out_of_hours_contact_phone: null,
            out_of_hours_contact_fax: null,
            out_of_hours_contact_email: null,
            pharmacy_groups: [],
            blood_result_providers: [],
        },
        pharmacy_siteSnapShot: {
            site_name: null,
            is_registered: false,
            name: null,
            address: null,
            post_code: null,
            phone: null,
            fax: null,
            email: null,
            pharmacy_group: null,
            blood_providers: null,
            chief_pharmacist_name: null,
            chief_pharmacist_phone: null,
            chief_pharmacist_fax: null,
            chief_pharmacist_email: null,
            chief_pharmacist_rpsgb_number: null,
            technician_name: null,
            technician_phone: null,
            technician_fax: null,
            technician_email: null,
            technician_rpsgb_number: null,
            out_of_hours_contact_name: null,
            out_of_hours_contact_phone: null,
            out_of_hours_contact_fax: null,
            out_of_hours_contact_email: null,
            pharmacy_groups: [],
            blood_result_providers: [],
        },
        errorMessages: {
            pharmacy_site: {
                is_registered: [],
                site_name: [],
                address: [],
                post_code: [],
                phone: [],
                fax: [],
                email: [],
                pharmacy_group: [],
                blood_providers: [],
                chief_pharmacist_name: [],
                chief_pharmacist_phone: [],
                chief_pharmacist_fax: [],
                chief_pharmacist_email: [],
                chief_pharmacist_rpsgb_number: [],
                technician_name: [],
                technician_phone: [],
                technician_fax: [],
                technician_email: [],
                technician_rpsgb_number: [],
                out_of_hours_contact_name: [],
                out_of_hours_contact_phone: [],
                out_of_hours_contact_fax: [],
                out_of_hours_contact_email: [],
                blood_result_providers: [],
            },
        },
        pharmacySitesOptions: [],
        pharmacyGroupOptions: [],
        bloodProvidersOptions: [],
        updatedProps: [],
    },
    mutations: {
        SET_PHARMACY_SITE_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // state.patient[data.property] = data.value;
        },
        SET_PHARMACY_GROUP_OPTIONS(state, data) {
            state.pharmacyGroupOptions = data;
        },
        SET_BLOOD_PROVIDERS_OPTIONS(state, data) {
            state.bloodProvidersOptions = data;
        },
        SET_PHARMACY_SITE(state, data) {
            state.pharmacy_site = data;
        },
        SET_PHARMACY_SITE_SNAP_SHOT(state, data) {
            state.pharmacy_siteSnapShot = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
        SET_PHARMACY_SITES_OPTIONS(state, data) {
            state.pharmacySitesOptions = data;
        },
    },
    actions: {
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        loadPharmacySiteSnapShot({ commit }, data) {
            commit('SET_PHARMACY_SITE_SNAP_SHOT', data);
        },
        async loadPharmacySitesOptions({ commit }) {
            return await axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        sort: 'name',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_SITES_OPTIONS', data);
                });
        },
        loadPharmacyOptions({ commit }) {
            axios
                .get(
                    route('api.v1.pharmacy-groups.options', {
                        sort: 'name',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_GROUP_OPTIONS', data);
                });
        },
        loadBloodProvidersOptions({ commit, state }, meta = null) {
            if (meta && meta.indclude) {
                return axios
                    .get(
                        route('api.v1.providers.options', {
                            sort: 'name',
                            allowed_providers: 'pharmacy_site',
                            not_assigned: state.pharmacy_site.id ? state.pharmacy_site.id : true,
                        })
                    )
                    .then((response) => {
                        const mappedMetaIs = meta.indclude.map((x) => x.id);
                        const data = response.data.data;
                        const registeredData = data.filter((x) => x.is_registered);
                        const disabledItems = data.filter((x) => mappedMetaIs.includes(x.id));
                        const mergedData = _.concat(registeredData, disabledItems);
                        const filtredData = _.clone(mergedData).map((x) => {
                            return {
                                ...x,
                                disabled: !x.is_registered,
                            };
                        });
                        commit('SET_BLOOD_PROVIDERS_OPTIONS', filtredData);
                    });
            }
            axios
                .get(
                    route('api.v1.providers.options', {
                        not_assigned: state.pharmacy_site.id ? state.pharmacy_site.id : true,
                        sort: 'name',
                        is_registered: 1,
                        allowed_providers: 'pharmacy_site',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_BLOOD_PROVIDERS_OPTIONS', data);
                });
        },
        updateProperty({ commit }, data) {
            commit('SET_PHARMACY_SITE_PROPERTY', data);
        },
        loadPharmacySite({ commit }, data) {
            commit('SET_PHARMACY_SITE', data);
            // for (let property of Object.keys(data)) {
            //     commit('SET_PATIENT_PROPERTY', { property, value: data[property] });
            // }
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.pharmacy_site, fieldErrors.field);

                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'pharmacy_site.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default PharmacySites;
